<template>
  <div>
  <TopNavigation activeApp="Ops Portal Home"/>
  <h1>Ops Portal Home</h1>
  </div>
</template>

<script>
import TopNavigation from '@/components/TopNavigation.vue'

export default {
  name: 'home',
  components: {
    TopNavigation
  },
  data() {
    return {
    }
  }
}
</script>

